<ng-container *ngFor="let item of menuBarItems">
  <ng-container [ngSwitch]="item.name">
    <ng-container *ngSwitchDefault>
      <div
        class="button-list slide-toggle-css"
        *ngIf="item.isVisible()"
        (click)="click(item)"
        [ngClass]="{ selected: item.selected(item.tabIndex), disabled: item.isDisabled(item.tabIndex) }"
        [soti-tooltip]="item.tooltip()"
        placement="left"
        [@expandCollapseAnimation]="expandCollapseAnimationTrigger(item)"
      >
        <span class="hd-icon {{ item.icon() }} icon-lg menu-item-icon {{ item.cssClass ? item.cssClass() : '' }}">
          <mat-spinner
            class="button-spinner"
            [diameter]="30"
            [strokeWidth]="2"
            *ngIf="item.spinning && item.spinning()"
          >
          </mat-spinner>
        </span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'download device logs'">
      <div
        class="button-list slide-toggle-css"
        *ngIf="item.isVisible() && isRemoteControlling()" 
        (click)="click(item)"
        [ngClass]="{ selected: deviceLogsSelector.isSelected, disabled: item.isDisabled(item.tabIndex) }"
        [soti-tooltip]="item.tooltip()"
        placement="left"
        [@expandCollapseAnimation]="expandCollapseAnimationTrigger(item)"
      >
        <span
          class="hd-icon {{ item.icon() }} icon-lg menu-item-icon download-device-logs-button {{
            item.cssClass ? item.cssClass() : ''
          }}"
        >
          <mat-spinner
            class="button-spinner"
            [diameter]="30"
            [strokeWidth]="2"
            *ngIf="item.spinning && item.spinning()"
          >
          </mat-spinner>
          <div
            [sotiPopupTriggerFor]="deviceLogsSelectorPopup"
            #deviceLogsSelectorTrigger="sotiPopupTrigger"
            id="deviceLogsSelectorTrigger"
          ></div>
        </span>
        <soti-popup #deviceLogsSelectorPopup="sotiPopup" position="endCenter">
          <app-remote-control-device-logs-selector
            #deviceLogsSelector
            [rcState]="rcState"
            [popUpTrigger]="deviceLogsSelectorTrigger"
          >
          </app-remote-control-device-logs-selector>
        </soti-popup>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<div
  class="button-toggle"
  *ngIf="collapsible"
  [ngClass]="{ 'icon-up': isMenuCollapsed, 'icon-down': !isMenuCollapsed }"
  (click)="toggleMenu()"
  [soti-tooltip]="getToggleButtonTooltip()"
  placement="left"
>
  <span class="hd-icon {{ getToggleButtonIcon() }} icon-lg menu-item-icon "> </span>
</div>
